export default "__VITE_ASSET__BWMXho4N__"